import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "g-container pl-[16px] sm:pl-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl sm:text-4xl leading-[50px] font-normal text-gary-line-color pt-[20px]" }, " 我的禮物清單 ", -1)
const _hoisted_3 = { class: "shopping-cart-breadcrumb leading-[18px] items-center flex gap-3 text-xs sm:text-[13px] font-bold flex mb-[21px] mt-1.5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "tab first:ml-0" }, "01 購物車", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, "02 運送資料&結帳", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "tab" }, ">", -1)
const _hoisted_8 = { class: "g-container" }
const _hoisted_9 = { class: "flex flex-col items-center mb-[20px] mx-[16px] border-b-2 border-black-300-color pt-[46px] sm:pt-[53px]" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center mx-[16px]"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[24px] mb-2 text-xl sm:text-4xl text-gary-line-color font-normal" }, " 禮物訂購完成 ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[28px] text-xs sm:text-base font-medium text-gary-line-color" }, " 馬上製作包裝中，請關注訂單動態... ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col items-center mx-[16px]"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt-[24px] mb-2 text-xl sm:text-4xl text-gary-line-color font-normal" }, " 禮物訂單成立 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[28px] text-xs sm:text-base font-medium text-gary-line-color" }, " 提醒您，請於時間內完成匯款才算訂購成功唷~ ", -1)
const _hoisted_17 = { class: "flex flex-col gap-2 text-sm text-breadcrumb-color font-medium mb-[30px]" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col sm:flex-row gap-5 sm:gap-2.5 mt-2.5"
}
const _hoisted_20 = { class: "flex flex-col grow gap-2.5" }
const _hoisted_21 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_22 = { class: "flex mt-5" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_24 = { class: "w-[80px]" }
const _hoisted_25 = { class: "grow flex flex-col" }
const _hoisted_26 = { class: "flex ml-[30px]" }
const _hoisted_27 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_28 = { class: "text-base font-medium text-gary-text-color" }
const _hoisted_29 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_30 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_31 = { class: "hidden" }
const _hoisted_32 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_34 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_36 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "grow h-[60px] flex items-center" }
const _hoisted_42 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_43 = { class: "flex-1 mr-[30px]" }
const _hoisted_44 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_45 = {
  key: 0,
  class: "flex"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[30px]" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:block sm:w-[130px]" }, null, -1)
const _hoisted_48 = { class: "grow flex flex-col" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "w-[46%]" }
const _hoisted_51 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-sm" }
const _hoisted_52 = { class: "flex mb-[20px]" }
const _hoisted_53 = { class: "w-[80px] mr-[20px]" }
const _hoisted_54 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color mb-1" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "包裝盒 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "吊卡 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "貼紙 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "防塵袋 x1"),
  /*#__PURE__*/_createElementVNode("li", null, "紙袋 x1")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_57 = { class: "grow flex" }
const _hoisted_58 = { class: "grow text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right mr-[30px]" }
const _hoisted_59 = {
  key: 1,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_60 = { class: "bg-img-background flex pt-[20px]" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_62 = { class: "w-[80px]" }
const _hoisted_63 = { class: "grow flex flex-col" }
const _hoisted_64 = { class: "flex ml-[30px]" }
const _hoisted_65 = { class: "w-[46%]" }
const _hoisted_66 = { class: "flex" }
const _hoisted_67 = { class: "w-[20px] mr-1.5" }
const _hoisted_68 = { class: "flex items-center mb-1.5 font-medium text-sm text-gary-text-color" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
    /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
    /*#__PURE__*/_createElementVNode("li", null, "霧面")
  ])
], -1)
const _hoisted_70 = { class: "grow h-[60px] flex items-center" }
const _hoisted_71 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_72 = { class: "grow mr-[30px]" }
const _hoisted_73 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_74 = {
  key: 2,
  class: "border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "w-[50px]" }, null, -1)
const _hoisted_76 = { class: "w-[80px]" }
const _hoisted_77 = { class: "grow flex flex-col" }
const _hoisted_78 = { class: "flex ml-[30px]" }
const _hoisted_79 = { class: "w-[46%]" }
const _hoisted_80 = { class: "flex" }
const _hoisted_81 = { class: "w-[20px] mr-1.5" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
    /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
    /*#__PURE__*/_createElementVNode("li", null, "霧面")
  ])
], -1)
const _hoisted_83 = { class: "grow h-[60px] flex items-center" }
const _hoisted_84 = { class: "grow mr-[30px]" }
const _hoisted_85 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_86 = { class: "flex gap-[14px] tracking-[.06em] mr-7 text-sm items-center text-gary-text-color" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_88 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_89 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_91 = { class: "w-[60px]" }
const _hoisted_92 = { class: "grow flex flex-col" }
const _hoisted_93 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_94 = { class: "flex flex-col gap-1" }
const _hoisted_95 = { class: "flex flex-row justify-between" }
const _hoisted_96 = { class: "" }
const _hoisted_97 = { class: "text-[13px] font-medium text-gary-text-color" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_100 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_101 = { class: "hidden" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_104 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_108 = [
  _hoisted_105,
  _hoisted_106,
  _hoisted_107
]
const _hoisted_109 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_110 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_111 = { class: "mr-[16px]" }
const _hoisted_112 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_113 = {
  key: 0,
  class: "flex flex-row mt-5 mb-3"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_115 = { class: "w-[60px]" }
const _hoisted_116 = { class: "grow flex flex-col" }
const _hoisted_117 = { class: "flex flex-col ml-[6px]" }
const _hoisted_118 = { class: "flex flex-col gap-1 sm:w-[46%]" }
const _hoisted_119 = { class: "flex flex-row justify-between" }
const _hoisted_120 = { class: "" }
const _hoisted_121 = { class: "flex items-center mb-1.5 text-gary-text-color tracking-[.06em] text-xs" }
const _hoisted_122 = { class: "flex" }
const _hoisted_123 = { class: "whitespace-pre-line tracking-widest text-xs leading-5 text-light-gary-text-color" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "hidden grow text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny ", -1)
const _hoisted_125 = { class: "grow h-[37px] flex flex-row items-center justify-end" }
const _hoisted_126 = { class: "mr-[16px]" }
const _hoisted_127 = { class: "text-[13px] sm:leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_128 = {
  key: 1,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_129 = { class: "bg-img-background flex pt-[20px] flex-row pt-5 pb-5" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_131 = { class: "w-[60px]" }
const _hoisted_132 = { class: "grow flex flex-col" }
const _hoisted_133 = { class: "flex flex-col ml-[6px]" }
const _hoisted_134 = { class: "flex flex-col gap-1" }
const _hoisted_135 = { class: "flex flex-row justify-between" }
const _hoisted_136 = { class: "" }
const _hoisted_137 = { class: "flex" }
const _hoisted_138 = { class: "w-[20px] mr-1.5" }
const _hoisted_139 = { class: "items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_141 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_142 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_143 = { class: "mr-[16px]" }
const _hoisted_144 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_145 = {
  key: 2,
  class: "flex flex-col border-t-[1px] border-black-300-color divide-y"
}
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[26px]" }, null, -1)
const _hoisted_147 = { class: "w-[60px]" }
const _hoisted_148 = { class: "grow flex flex-col" }
const _hoisted_149 = { class: "flex flex-col ml-[6px]" }
const _hoisted_150 = { class: "flex flex-col gap-1" }
const _hoisted_151 = { class: "flex flex-row justify-between" }
const _hoisted_152 = { class: "" }
const _hoisted_153 = { class: "flex" }
const _hoisted_154 = { class: "w-[20px] mr-1.5" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("ul", { class: "hidden list-none w-[70px] text-xs leading-5 text-light-gary-text-color" }, [
  /*#__PURE__*/_createElementVNode("li", null, "15x16cm"),
  /*#__PURE__*/_createElementVNode("li", null, "霧面")
], -1)
const _hoisted_156 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_157 = { class: "mr-[16px]" }
const _hoisted_158 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_159 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center text-gary-text-color" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_161 = {
  key: 0,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_162 = { class: "w-[20px] mr-2.5" }
const _hoisted_163 = /*#__PURE__*/_createTextVNode(" 加購商品")
const _hoisted_164 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_165 = { class: "flex mt-5" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_167 = { class: "w-[80px]" }
const _hoisted_168 = { class: "grow flex flex-col" }
const _hoisted_169 = { class: "flex ml-[30px]" }
const _hoisted_170 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_171 = { class: "flex text-base font-medium text-gary-text-color" }
const _hoisted_172 = { class: "w-[20px] mr-1.5" }
const _hoisted_173 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_174 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_175 = { class: "hidden" }
const _hoisted_176 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_177 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_178 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_179 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_180 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_181 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_184 = [
  _hoisted_181,
  _hoisted_182,
  _hoisted_183
]
const _hoisted_185 = { class: "grow h-[60px] flex items-center" }
const _hoisted_186 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_187 = { class: "flex-1 mr-[30px]" }
const _hoisted_188 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_189 = { class: "flex justify-end py-1.5 border-t-[1px] border-black-300-color" }
const _hoisted_190 = { class: "flex gap-[14px] tracking-[.06em] mr-7 text-sm items-center text-gary-text-color" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_192 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_193 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_195 = { class: "w-[60px]" }
const _hoisted_196 = { class: "grow flex flex-col" }
const _hoisted_197 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_198 = { class: "flex flex-col gap-1" }
const _hoisted_199 = { class: "flex flex-row justify-between" }
const _hoisted_200 = { class: "" }
const _hoisted_201 = { class: "flex text-[13px] font-medium text-gary-text-color" }
const _hoisted_202 = { class: "w-[20px] mr-1.5" }
const _hoisted_203 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_204 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_205 = { class: "hidden" }
const _hoisted_206 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_207 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_208 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_209 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_212 = [
  _hoisted_209,
  _hoisted_210,
  _hoisted_211
]
const _hoisted_213 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_214 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_215 = { class: "mr-[16px]" }
const _hoisted_216 = { class: "text-[13px] items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_217 = { class: "flex justify-end px-[16px] py-3 border-t-[1px] border-black-300-color" }
const _hoisted_218 = { class: "flex gap-[14px] tracking-[.06em] text-sm items-center text-gary-text-color" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("div", { class: "leading-[17px] text-xs" }, "商品小計", -1)
const _hoisted_220 = {
  key: 1,
  class: "flex leading-[26px] items-center text-gary-text-color tracking-[.06em] pl-[16px] sm:pl-0"
}
const _hoisted_221 = { class: "w-[20px] mr-2.5" }
const _hoisted_222 = /*#__PURE__*/_createTextVNode(" 贈品")
const _hoisted_223 = { class: "hidden sm:flex bg-white flex-col rounded-md top-[50px]" }
const _hoisted_224 = { class: "flex mt-5 min-h-[100px]" }
const _hoisted_225 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[20px] mr-[30px] items-center" }, null, -1)
const _hoisted_226 = { class: "w-[80px]" }
const _hoisted_227 = { class: "grow flex flex-col" }
const _hoisted_228 = { class: "flex ml-[30px]" }
const _hoisted_229 = { class: "flex flex-col gap-1 w-[46%]" }
const _hoisted_230 = { class: "flex text-sm font-medium text-gary-text-color" }
const _hoisted_231 = { class: "mr-1.5 w-[20px]" }
const _hoisted_232 = { class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color" }
const _hoisted_233 = {
  key: 0,
  class: "text-[13px] tracking-[.12em] leading-5 text-light-gary-text-color"
}
const _hoisted_234 = { class: "hidden" }
const _hoisted_235 = {
  key: 0,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_236 = /*#__PURE__*/_createTextVNode("顯示產品詳細資訊")
const _hoisted_237 = {
  key: 1,
  class: "leading-[18px] tracking-[.12em] items-center gap-0.5 flex"
}
const _hoisted_238 = /*#__PURE__*/_createTextVNode("隱藏產品詳細資訊")
const _hoisted_239 = {
  key: 0,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_240 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_243 = [
  _hoisted_240,
  _hoisted_241,
  _hoisted_242
]
const _hoisted_244 = { class: "grow h-[60px] flex items-center" }
const _hoisted_245 = { class: "w-[70px] font-medium text-gary-text-color text-base text-right" }
const _hoisted_246 = { class: "sm:hidden bg-white flex flex-col sticky top-[50px]" }
const _hoisted_247 = { class: "flex flex-row mt-5 mb-3" }
const _hoisted_248 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row h-[80px] ml-[16px] mr-[10px] items-center" }, null, -1)
const _hoisted_249 = { class: "w-[60px]" }
const _hoisted_250 = { class: "grow flex flex-col" }
const _hoisted_251 = { class: "flex flex-col ml-[6px] mb-2.5" }
const _hoisted_252 = { class: "flex flex-col gap-1" }
const _hoisted_253 = { class: "flex flex-row justify-between" }
const _hoisted_254 = { class: "" }
const _hoisted_255 = { class: "text-[13px] font-medium text-gary-text-color" }
const _hoisted_256 = { class: "text-xs leading-5 text-light-gary-text-color" }
const _hoisted_257 = {
  key: 0,
  class: "text-xs leading-5 text-light-gary-text-color"
}
const _hoisted_258 = { class: "hidden" }
const _hoisted_259 = /*#__PURE__*/_createTextVNode(" 顯示產品詳細資訊")
const _hoisted_260 = /*#__PURE__*/_createTextVNode(" 隱藏產品詳細資訊")
const _hoisted_261 = {
  key: 2,
  class: "list-none text-[13px] tracking-[.12em] text-breadcrumb-color"
}
const _hoisted_262 = /*#__PURE__*/_createElementVNode("li", null, "寬30mm", -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("li", null, "長5米", -1)
const _hoisted_264 = /*#__PURE__*/_createElementVNode("li", null, "日本和紙", -1)
const _hoisted_265 = [
  _hoisted_262,
  _hoisted_263,
  _hoisted_264
]
const _hoisted_266 = { class: "grow mt-[20px] h-[37px] flex flex-row items-center justify-between" }
const _hoisted_267 = { class: "w-[70px] font-medium text-gary-text-color text-base" }
const _hoisted_268 = { class: "basis-[42%] flex flex-col gap-5 sm:gap-2.5 px-2.5 sm:px-0" }
const _hoisted_269 = { class: "bg-white rounded-md pt-[36px] px-[14px] sm:px-[30px] pb-[40px] divide-y-[1px]" }
const _hoisted_270 = { class: "flex flex-col pb-[40px] px-2.5 gap-[30px]" }
const _hoisted_271 = { class: "flex font-bold text-sm text-gary-text-color mb-2.5" }
const _hoisted_272 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "訂單狀態", -1)
const _hoisted_273 = { class: "grow text-right text-primary-color" }
const _hoisted_274 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[11px]" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2.5" }, "訂單編號", -1)
const _hoisted_276 = { class: "font-medium underline underline-offset-2" }
const _hoisted_277 = /*#__PURE__*/_createTextVNode(" # ")
const _hoisted_278 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 購買人 ", -1)
const _hoisted_279 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_280 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_281 = { class: "text-[13px] tracking-[.12em] text-gary-text-color" }
const _hoisted_282 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 收件資料 ", -1)
const _hoisted_283 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_284 = { class: "mr-[15px]" }
const _hoisted_285 = { class: "" }
const _hoisted_286 = { class: "flex text-sm tracking-[.06em] text-gary-text-color mb-[5px]" }
const _hoisted_287 = { class: "mr-[15px]" }
const _hoisted_288 = { class: "text-[13px] tracking-[.12em] text-gary-text-color" }
const _hoisted_289 = {
  key: 0,
  class: "sm:w-[45%] text-light-gary-text-color text-[13px] tracking-[.12em]"
}
const _hoisted_290 = {
  key: 1,
  class: "sm:w-[45%] text-light-gary-text-color text-[13px] mb-[5px] tracking-[.12em]"
}
const _hoisted_291 = /*#__PURE__*/_createTextVNode(" 據點地址｜")
const _hoisted_292 = { class: "cursor-pointer text-primary-color underline" }
const _hoisted_293 = {
  key: 3,
  class: "text-light-gary-text-color text-[13px] mb-[5px] tracking-[.12em]"
}
const _hoisted_294 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 發票類型 ", -1)
const _hoisted_295 = { key: 0 }
const _hoisted_296 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_297 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_298 = { key: 1 }
const _hoisted_299 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }, " 手機條碼載具 ", -1)
const _hoisted_300 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_301 = { key: 2 }
const _hoisted_302 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_303 = { class: "text-sm tracking-[.06em] text-gary-text-color mb-[3px]" }
const _hoisted_304 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_305 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-sm text-gary-text-color mb-2.5" }, " 訂單狀態 ", -1)
const _hoisted_306 = { class: "text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_307 = /*#__PURE__*/_createElementVNode("div", { class: "text-light-gary-text-color text-[13px] tracking-[.12em] mt-[20px]" }, " 以上訂單資料已發送到您的電子郵件。 如果該訂單資料沒有出現在收件夾，請檢查垃圾郵件箱。 ", -1)
const _hoisted_308 = { class: "flex flex-col divide-y-2 px-2.5 pt-[40px]" }
const _hoisted_309 = { class: "flex flex-col ml-1 gap-[18px] text-base text-gary-text-color mb-[20px]" }
const _hoisted_310 = { class: "flex" }
const _hoisted_311 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "商品金額", -1)
const _hoisted_312 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_313 = { class: "flex" }
const _hoisted_314 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "運費小計", -1)
const _hoisted_315 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_316 = { class: "flex" }
const _hoisted_317 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "優惠", -1)
const _hoisted_318 = { class: "grow text-right font-medium sm:font-bold" }
const _hoisted_319 = { class: "pt-[20px]" }
const _hoisted_320 = { class: "flex text-black-900-color leading-[23px] items-center" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("div", { class: "w-[64px] font-medium" }, "應付總額", -1)
const _hoisted_322 = { class: "grow text-lg text-right font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_UnderLine = _resolveComponent("UnderLine")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("ol", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("li", {
          class: _normalizeClass(["tab", [{ actived: true }]])
        }, "03 購物完成")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Icon, {
          class: "hidden sm:block",
          iconName: "gift",
          width: '120px'
        }),
        _createVNode(_component_Icon, {
          class: "sm:hidden",
          iconName: "gift",
          width: '80px'
        }),
        (_ctx.$route.query.orderid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.$route.params.orderId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", null, "訂單編號：" + _toDisplayString(_ctx.$route.params.orderId), 1),
                _createElementVNode("li", null, " 銀行名稱：" + _toDisplayString(` ${_ctx.$route.params.bankName} (${_ctx.$route.params.bankCode})`), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createTextVNode(" 繳款帳號：" + _toDisplayString(_ctx.$route.params.bankAccount), 1),
                    _createVNode(_component_Icon, {
                      class: "cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCopy('bankAccount'))),
                      onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCopy('bankAccount'))),
                      iconName: "copy2",
                      width: '24px'
                    })
                  ])
                ]),
                _createElementVNode("li", null, "付款期限：" + _toDisplayString(_ctx.$route.params.paymentDateLine), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "w-[126px] sm:w-[190px] mb-[60px] sm:mb-[115px] leading-[36px] sm:leading-[50px] text-center bg-gary-text-color text-white rounded-[10px] text-base cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'home' })))
        }, " 繼續購物 ")
      ]),
      (_ctx.orderDetail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemList, (orderItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: orderItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: orderItem.CmdyImage.PcWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdyName)), 1),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.unescapeHTML(orderItem.CmdySubName)), 1),
                            (orderItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 作品名稱：" + _toDisplayString(orderItem.EditorPortfolioName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                      _hoisted_33,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                      _hoisted_35,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_36, _hoisted_40))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, _toDisplayString(orderItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, " NT. " + _toDisplayString(orderItem.UnitFee), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (orderItem.PackageCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _hoisted_46,
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_UnderLine, { class: "w-auto ml-[111px] sm:ml-0 mb-5" }),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createVNode(_component_Icon, {
                                    class: "mr-1.5",
                                    iconName: "package",
                                    width: '20px'
                                  }),
                                  _createTextVNode("禮品包裝 - " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _createVNode(_component_SquareItemFullImage, {
                                      width: '80px',
                                      image: orderItem.PackageCmdyList[0].CmdyImage.PcWeb,
                                      customClass: 'square-photo-content-no-cursor'
                                    }, null, 8, ["image"])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, _toDisplayString(orderItem.PackageCmdyList[0].CmdyIncludeDesc), 1),
                                  _hoisted_55,
                                  _hoisted_56
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, " NT. " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyAmt), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.AddOnCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.AddOnCmdyList, (addOnCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: addOnCmdyItem.CmdyId,
                              class: "add-on-item"
                            }, [
                              _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createElementVNode("div", _hoisted_62, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '80px',
                                    image: addOnCmdyItem.CmdyImage.PcWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                          _createVNode(_component_Icon, {
                                            iconName: 'add_on'
                              ,
                                            width: '20px'
                                          })
                                        ]),
                                        _createElementVNode("span", _hoisted_68, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                      ]),
                                      _hoisted_69
                                    ]),
                                    _createElementVNode("div", _hoisted_70, [
                                      _createElementVNode("div", _hoisted_71, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                      _createElementVNode("div", _hoisted_72, [
                                        _createElementVNode("div", _hoisted_73, " NT." + _toDisplayString(addOnCmdyItem.UnitFee), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.GiveawayCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: giveawayCmdyItem.CmdyId,
                              class: "add-on-item"
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{
                    'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                    'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                  }, "flex pt-[20px]"])
                              }, [
                                _hoisted_75,
                                _createElementVNode("div", _hoisted_76, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '80px',
                                    image: giveawayCmdyItem.CmdyImage.PcWeb,
                                    customClass: 'square-photo-content-no-cursor'
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("div", _hoisted_81, [
                                          _createVNode(_component_Icon, {
                                            iconName: 
                                giveawayCmdyItem.CmdyQty == 0
                                  ? 'giveaway_gray'
                                  : 'giveaway_black'
                              ,
                                            width: '20px'
                                          }, null, 8, ["iconName"])
                                        ]),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["flex items-center mb-1.5 font-medium text-sm text-gary-text-color", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                      ]),
                                      _hoisted_82
                                    ]),
                                    _createElementVNode("div", _hoisted_83, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base text-right", {
                            'text-black-400-color':
                              giveawayCmdyItem.CmdyQty === 0
                          }])
                                      }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                      _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFee), 3)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createTextVNode(" NT. " + _toDisplayString(orderItem.TotalAmount), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: orderItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _createElementVNode("div", _hoisted_97, [
                                  (orderItem.CmdyType === 'Giveaway')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, "贈品 - "))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.unescapeHTML(orderItem.CmdyName)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_99, _toDisplayString(orderItem.CmdySubName), 1),
                                (orderItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_100, " 作品名稱：" + _toDisplayString(orderItem.EditorPortfolioName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_101, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_102,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_103,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_104, _hoisted_108))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, _toDisplayString(orderItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("div", _hoisted_112, " NT. " + _toDisplayString(orderItem.CmdyAmt), 1)
                            ])
                          ])
                        ]),
                        (orderItem.PackageCmdyList?.length !== 0)
                          ? (_openBlock(), _createBlock(_component_UnderLine, {
                              key: 0,
                              class: "w-auto ml-1"
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (orderItem.PackageCmdyList?.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                          _hoisted_114,
                          _createElementVNode("div", _hoisted_115, [
                            _createVNode(_component_SquareItemFullImage, {
                              width: '80px',
                              image: orderItem.PackageCmdyList[0].CmdyImage.MobileWeb,
                              customClass: ''
                            }, null, 8, ["image"])
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("div", _hoisted_119, [
                                  _createElementVNode("div", _hoisted_120, [
                                    _createElementVNode("div", _hoisted_121, [
                                      _createVNode(_component_Icon, {
                                        class: "mr-1.5",
                                        iconName: "package",
                                        width: '20px'
                                      }),
                                      _createTextVNode("禮品包裝 - " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyName), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_122, [
                                      _createElementVNode("div", _hoisted_123, _toDisplayString(orderItem.PackageCmdyList[0]
                                  .CmdyIncludeDesc), 1),
                                      _hoisted_124
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("div", _hoisted_126, [
                                  _createElementVNode("div", _hoisted_127, " NT. " + _toDisplayString(orderItem.PackageCmdyList[0].CmdyAmt), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.AddOnCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.AddOnCmdyList, (addOnCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex-row",
                              key: addOnCmdyItem.CmdyId
                            }, [
                              _createElementVNode("div", _hoisted_129, [
                                _hoisted_130,
                                _createElementVNode("div", _hoisted_131, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '60px',
                                    image: addOnCmdyItem.CmdyImage.MobileWeb,
                                    customClass: ''
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_132, [
                                  _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("div", _hoisted_134, [
                                      _createElementVNode("div", _hoisted_135, [
                                        _createElementVNode("div", _hoisted_136, [
                                          _createElementVNode("div", _hoisted_137, [
                                            _createElementVNode("div", _hoisted_138, [
                                              _createVNode(_component_Icon, {
                                                iconName: 'add_on'
                                  ,
                                                width: '20px'
                                              })
                                            ]),
                                            _createElementVNode("span", _hoisted_139, "加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName), 1)
                                          ]),
                                          _hoisted_140
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_141, [
                                      _createElementVNode("div", _hoisted_142, _toDisplayString(addOnCmdyItem.CmdyQty), 1),
                                      _createElementVNode("div", _hoisted_143, [
                                        _createElementVNode("div", _hoisted_144, " NT." + _toDisplayString(addOnCmdyItem.CmdyAmt), 1)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (orderItem.GiveawayCmdyList.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "flex-row",
                              key: giveawayCmdyItem.CmdyId
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass([{
                    'bg-black-300-color': giveawayCmdyItem.CmdyQty === 0,
                    'bg-img-background': giveawayCmdyItem.CmdyQty !== 0
                  }, "flex pt-[20px] flex-row pt-5 pb-5"])
                              }, [
                                _hoisted_146,
                                _createElementVNode("div", _hoisted_147, [
                                  _createVNode(_component_SquareItemFullImage, {
                                    width: '60px',
                                    image: giveawayCmdyItem.CmdyImage.MobileWeb,
                                    customClass: ''
                                  }, null, 8, ["image"])
                                ]),
                                _createElementVNode("div", _hoisted_148, [
                                  _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("div", _hoisted_150, [
                                      _createElementVNode("div", _hoisted_151, [
                                        _createElementVNode("div", _hoisted_152, [
                                          _createElementVNode("div", _hoisted_153, [
                                            _createElementVNode("div", _hoisted_154, [
                                              _createVNode(_component_Icon, {
                                                iconName: 
                                    giveawayCmdyItem.CmdyQty == 0
                                      ? 'giveaway_gray'
                                      : 'giveaway_black'
                                  ,
                                                width: '20px'
                                              }, null, 8, ["iconName"])
                                            ]),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["items-center tracking-[.06em] text-xs mb-1.5 text-gary-text-color", {
                                  'text-black-400-color':
                                    giveawayCmdyItem.CmdyQty === 0
                                }])
                                            }, "贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 3)
                                          ]),
                                          _hoisted_155
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_156, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["w-[70px] font-medium text-gary-text-color text-base", {
                            'text-black-400-color':
                              giveawayCmdyItem.CmdyQty === 0
                          }])
                                      }, _toDisplayString(giveawayCmdyItem.CmdyQty), 3),
                                      _createElementVNode("div", _hoisted_157, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["text-[13px] items-center text-gary-text-color tracking-[.06em] text-right", {
                              'text-black-400-color':
                                giveawayCmdyItem.CmdyQty === 0
                            }])
                                        }, " NT." + _toDisplayString(giveawayCmdyItem.UnitFee), 3)
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_158, [
                      _createElementVNode("div", _hoisted_159, [
                        _hoisted_160,
                        _createTextVNode(" NT. " + _toDisplayString(orderItem.TotalAmount), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.addOnItemList.length !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, [
                      _createVNode(_component_Icon, {
                        iconName: 'add_on',
                        width: '20px'
                      })
                    ]),
                    _hoisted_163
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addOnItemList, (addOnItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: addOnItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _hoisted_166,
                      _createElementVNode("div", _hoisted_167, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: addOnItem.CmdyImage.PcWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _createElementVNode("div", _hoisted_172, [
                                _createVNode(_component_Icon, {
                                  iconName: 'add_on'
                              ,
                                  width: '20px'
                                })
                              ]),
                              _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdyName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_173, _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdySubName)), 1),
                            (addOnItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_174, " 作品名稱：" + _toDisplayString(addOnItem.EditorPortfolioName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_175, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_176, [
                                      _hoisted_177,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_178, [
                                      _hoisted_179,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_180, _hoisted_184))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_185, [
                            _createElementVNode("div", _hoisted_186, _toDisplayString(addOnItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_187, [
                              _createElementVNode("div", _hoisted_188, " NT. " + _toDisplayString(addOnItem.CmdyAmt), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_189, [
                      _createElementVNode("div", _hoisted_190, [
                        _hoisted_191,
                        _createTextVNode(" NT. " + _toDisplayString(addOnItem.TotalAmount), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_192, [
                    _createElementVNode("div", _hoisted_193, [
                      _hoisted_194,
                      _createElementVNode("div", _hoisted_195, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: addOnItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("div", _hoisted_197, [
                          _createElementVNode("div", _hoisted_198, [
                            _createElementVNode("div", _hoisted_199, [
                              _createElementVNode("div", _hoisted_200, [
                                _createElementVNode("div", _hoisted_201, [
                                  _createElementVNode("div", _hoisted_202, [
                                    _createVNode(_component_Icon, {
                                      iconName: 'add_on'
                              ,
                                      width: '20px'
                                    })
                                  ]),
                                  _createTextVNode(" 加購商品 - " + _toDisplayString(_ctx.unescapeHTML(addOnItem.CmdyName)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_203, _toDisplayString(addOnItem.CmdySubName), 1),
                                (addOnItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_204, " 作品名稱：" + _toDisplayString(addOnItem.EditorPortfolioName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_205, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_206,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_207,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_208, _hoisted_212))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_213, [
                            _createElementVNode("div", _hoisted_214, _toDisplayString(addOnItem.CmdyQty), 1),
                            _createElementVNode("div", _hoisted_215, [
                              _createElementVNode("div", _hoisted_216, " NT. " + _toDisplayString(addOnItem.CmdyAmt), 1)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_217, [
                      _createElementVNode("div", _hoisted_218, [
                        _hoisted_219,
                        _createTextVNode(" NT. " + _toDisplayString(addOnItem.TotalAmount), 1)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.giveawayItemList.length !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_220, [
                    _createElementVNode("div", _hoisted_221, [
                      _createVNode(_component_Icon, {
                        iconName: 'giveaway_black',
                        width: '20px'
                      })
                    ]),
                    _hoisted_222
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giveawayItemList, (giveawayItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: giveawayItem.OrderItemId,
                  class: "flex flex-col gap-2.5"
                }, [
                  _createElementVNode("div", _hoisted_223, [
                    _createElementVNode("div", _hoisted_224, [
                      _hoisted_225,
                      _createElementVNode("div", _hoisted_226, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '80px',
                          image: giveawayItem.CmdyImage.PcWeb,
                          customClass: 'square-photo-content-no-cursor'
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_227, [
                        _createElementVNode("div", _hoisted_228, [
                          _createElementVNode("div", _hoisted_229, [
                            _createElementVNode("div", _hoisted_230, [
                              _createElementVNode("div", _hoisted_231, [
                                _createVNode(_component_Icon, {
                                  iconName: 'giveaway_black',
                                  width: '20px'
                                })
                              ]),
                              _createTextVNode(" 贈品 - " + _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdyName)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_232, _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdySubName)), 1),
                            (giveawayItem.EditorPortfolioId !== '')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_233, " 作品名稱：" + _toDisplayString(giveawayItem.EditorPortfolioName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_234, [
                              _createElementVNode("div", {
                                class: "text-xs text-primary-color cursor-pointer",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.detail = !_ctx.detail))
                              }, [
                                (!_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_235, [
                                      _hoisted_236,
                                      (!_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_down",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.detail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_237, [
                                      _hoisted_238,
                                      (_ctx.detail)
                                        ? (_openBlock(), _createBlock(_component_Icon, {
                                            key: 0,
                                            iconName: "arrow_up",
                                            width: '12px'
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.detail)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_239, _hoisted_243))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_244, [
                            _createElementVNode("div", _hoisted_245, _toDisplayString(giveawayItem.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_246, [
                    _createElementVNode("div", _hoisted_247, [
                      _hoisted_248,
                      _createElementVNode("div", _hoisted_249, [
                        _createVNode(_component_SquareItemFullImage, {
                          width: '60px',
                          image: giveawayItem.CmdyImage.MobileWeb,
                          customClass: ''
                        }, null, 8, ["image"])
                      ]),
                      _createElementVNode("div", _hoisted_250, [
                        _createElementVNode("div", _hoisted_251, [
                          _createElementVNode("div", _hoisted_252, [
                            _createElementVNode("div", _hoisted_253, [
                              _createElementVNode("div", _hoisted_254, [
                                _createElementVNode("div", _hoisted_255, _toDisplayString(_ctx.unescapeHTML(giveawayItem.CmdyName)), 1),
                                _createElementVNode("div", _hoisted_256, _toDisplayString(giveawayItem.CmdySubName), 1),
                                (giveawayItem.EditorPortfolioId !== '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_257, " 作品名稱：" + _toDisplayString(giveawayItem.EditorPortfolioName), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_258, [
                                  (!_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_259,
                                        (!_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_down",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "flex leading-[18px] tracking-[.12em] items-center gap-0.5 text-xs text-primary-color cursor-pointer",
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.detail = !_ctx.detail))
                                      }, [
                                        _hoisted_260,
                                        (_ctx.detail)
                                          ? (_openBlock(), _createBlock(_component_Icon, {
                                              key: 0,
                                              iconName: "arrow_up",
                                              width: '12px'
                                            }))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.detail)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_261, _hoisted_265))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_266, [
                            _createElementVNode("div", _hoisted_267, _toDisplayString(giveawayItem.CmdyQty), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_268, [
              _createElementVNode("div", _hoisted_269, [
                _createElementVNode("div", _hoisted_270, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_271, [
                      _hoisted_272,
                      _createElementVNode("div", _hoisted_273, _toDisplayString(_ctx.orderDetail.StatusDesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_274, [
                      _hoisted_275,
                      _createElementVNode("div", _hoisted_276, [
                        _hoisted_277,
                        _createElementVNode("span", { ref: "copyOrderId" }, _toDisplayString(_ctx.orderDetail.OrderId), 513)
                      ]),
                      _createVNode(_component_Icon, {
                        class: "cursor-pointer",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCopy('orderId'))),
                        onKeyup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCopy('orderId'))),
                        iconName: "copy2",
                        width: '24px'
                      })
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_278,
                    _createElementVNode("div", _hoisted_279, _toDisplayString(_ctx.orderDetail.BuyerName), 1),
                    _createElementVNode("div", _hoisted_280, _toDisplayString(_ctx.orderDetail.BuyerEmail), 1),
                    _createElementVNode("div", _hoisted_281, _toDisplayString(_ctx.orderDetail.BuyerMobile), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_282,
                    _createElementVNode("div", _hoisted_283, [
                      _createElementVNode("div", _hoisted_284, _toDisplayString(_ctx.orderDetail.DeliveryTypeDesc), 1),
                      _createElementVNode("div", _hoisted_285, "NT. " + _toDisplayString(_ctx.orderDetail.FreightAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_286, [
                      _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.orderDetail.ReceiverName), 1),
                      _createElementVNode("div", _hoisted_288, _toDisplayString(_ctx.orderDetail.ReceiverMobile), 1)
                    ]),
                    (_ctx.orderDetail.DeliveryType === 'Home')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_289, _toDisplayString(_ctx.orderDetail.DeliveryCity +
                  _ctx.orderDetail.DeliveryDist +
                  _ctx.orderDetail.DeliveryAddr), 1))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.DeliveryType === 'GainHowShopSeller')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_290, _toDisplayString(_ctx.orderDetail.DeliveryDestName), 1))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.DeliveryType === 'GainHowShopSeller')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "text-light-gary-text-color text-[13px] mb-[5px] tracking-[.12em]",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openMap && _ctx.openMap(...args)))
                        }, [
                          _hoisted_291,
                          _createElementVNode("span", _hoisted_292, [
                            _createTextVNode(_toDisplayString(_ctx.orderDetail.DeliveryDestShopAddr), 1),
                            _createVNode(_component_Icon, {
                              class: "inline-block mb-[2px]",
                              iconName: "maps",
                              width: '20px'
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.DeliveryType === 'GainHowShopSeller')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_293, " 營業時間｜" + _toDisplayString(_ctx.orderDetail.DeliveryDestShopBusinessHours), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_294,
                    (_ctx.orderDetail.InvoiceCarrierType === 'Member')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                          _createElementVNode("div", _hoisted_296, _toDisplayString(_ctx.orderDetail.InvoiceTypeDesc), 1),
                          _createElementVNode("div", _hoisted_297, _toDisplayString(_ctx.orderDetail.InvoiceEmail), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.InvoiceCarrierType === 'Barcode')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                          _hoisted_299,
                          _createElementVNode("div", _hoisted_300, _toDisplayString(_ctx.orderDetail.InvoiceCarrier), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.orderDetail.InvoiceCarrierType === 'None')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_301, [
                          _createElementVNode("div", _hoisted_302, _toDisplayString(_ctx.orderDetail.InvoiceTypeDesc), 1),
                          _createElementVNode("div", _hoisted_303, " 統一編號 " + _toDisplayString(_ctx.orderDetail.InvoiceBizNo), 1),
                          _createElementVNode("div", _hoisted_304, _toDisplayString(_ctx.orderDetail.InvoiceEmail), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_305,
                    _createElementVNode("div", _hoisted_306, _toDisplayString(_ctx.orderDetail.PaymentTypeDesc), 1),
                    _hoisted_307
                  ])
                ]),
                _createElementVNode("div", _hoisted_308, [
                  _createElementVNode("div", _hoisted_309, [
                    _createElementVNode("div", _hoisted_310, [
                      _hoisted_311,
                      _createElementVNode("div", _hoisted_312, " NT. " + _toDisplayString(_ctx.orderDetail.CmdyAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_313, [
                      _hoisted_314,
                      _createElementVNode("div", _hoisted_315, " NT. " + _toDisplayString(_ctx.orderDetail.FreightAmt), 1)
                    ]),
                    _createElementVNode("div", _hoisted_316, [
                      _hoisted_317,
                      _createElementVNode("div", _hoisted_318, " - NT. " + _toDisplayString(_ctx.orderDetail.Discount), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_319, [
                    _createElementVNode("div", _hoisted_320, [
                      _hoisted_321,
                      _createElementVNode("div", _hoisted_322, " NT. " + _toDisplayString(_ctx.orderDetail.TotalAmount), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}